module.exports = __webpack_public_path__ + "img/persistence-badge.681eb6af.png";